import CompanyMessage from "../../components/companyMessage/CompanyMessage"

function CompanyMessagePage() {
    return (
        <>
        <CompanyMessage/>
        </>
    )
}
export default CompanyMessagePage